import { AbstractCommand, StateService, CommandInterfaces, Command } from 'flux-core';
import { Injectable } from '@angular/core';

/**
 * CreateIntegration
 */
@Injectable()
@Command()
export class CreateIntegration extends AbstractCommand {

    public static get implements(): Array<CommandInterfaces> {
        return [ 'IStateChangeCommand' ];
    }

    /**
     * Command input data format
     */
    public stateData: any;

    constructor( protected state: StateService<any, any> ) {
        super()/* istanbul ignore next */;
    }

    public get states(): { [ stateId: string ]: any } {
        return this.data.stateData;
    }

    public prepareData(): void {

    }

    public execute (): boolean {
        this.state.set( 'OpenRightSidebar', 'convertcards' );
        this.state.set( 'CardConvertType', this.states.selectedConvertType );
        return true;
    }

}

Object.defineProperty( CreateIntegration, 'name', {
    value: 'CreateIntegration',
});
